import isBlank from "@sedan-utils/is-blank";
import { AdapterBase, RunResponse, RunResponseType } from "../../storyV2/adapter/AdapterBase";
import { StoryNodeType } from "../../storyV2/domain/StoryNodeType";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
import { EdgeState } from "../../storyV2/domain/StoryEdge";
export class RrrrAdapter extends AdapterBase {
    async run(story, edge, sourceNode, actionData) {
        const node = sourceNode;
        if (node === undefined) {
            return Promise.reject();
        }
        switch (node.options.type) {
            case StoryNodeType.CUSTOMGROUP:
                // TODO
                return Promise.reject();
            case StoryNodeType.CUSTOMNODE:
                const res = await this.runSingle(node.content, actionData, story, edge);
                return new RunResponse(RunResponseType.IMAGE_GROUP, res);
        }
    }
    async runSingle(input, actionData, story, edge) {
        if (isBlank(input)) {
            return Promise.reject();
        }
        const res = await FunctionUtil.findFuncAndRun(input, actionData, this.funcRegistry, FunctionUtil.createFuncVariables(story, edge), { projectId: story.projectId, edgeId: edge.options.id }, () => edge.state === EdgeState.ERROR);
        return res.data;
    }
}
